import React from 'react';
import { Switch } from 'react-router-dom';

// LandlordApp
import PropertyType from '../components/landlordApp/PropertyType';
import Declaration from '../components/landlordApp/Declaration';
import InstallerDetails from '../components/landlordApp/InstallerDetails';
import InstallationAddress from '../components/landlordApp/InstallationAddress';
import InstallerConfirm from '../components/landlordApp/InstallerConfirm';
import BuildingType from '../components/landlordApp/BuildingType';
import ParkingType from '../components/landlordApp/ParkingType';
import ChargepointInstallation from '../components/landlordApp/ChargepointInstallation';
import CheckYourPropertyAnswers from '../components/landlordApp/CheckAnswersProperty';
import UnableToProceed from '../components/landlordApp/UnableToProceed';
import UnableToStartNewApplication from '../components/landlordApp/UnableToStartNewApplication';
import ApplicationSubmitted from '../components/landlordApp/ApplicationSubmitted';
import SelectGrantType from '../components/landlordApp/SelectGrantType';
import StaffFleetChargepoints from '../components/landlordApp/StaffFleetChargepoints';
import UnableToProceedStaffOrFleetUsage from '../components/landlordApp/UnableToProceedStaffOrFleetUsage';
import LandlordOrPmcPrivateParking from '../components/landlordApp/LandlordOrPmcPrivateParking';
import AuthRoute from '../AuthRoute';
import ChallangeInstallation from '../components/landlordApp/ChallangeInstallation';
import ChallengeSubmitted from '../components/landlordReg/ChallengeSubmitted';

export default function RoutesTreeLandlordApp() {
  return (
    <Switch>
      {/* *************************** */}
      {/* Landlord Application routes */}
      {/* *************************** */}
      <AuthRoute exact path="/landlordApp/declaration">
        <Declaration />
      </AuthRoute>
      {/* The following three Routes are created with a component prop in order to have location
      prop passed to it by the Change Link on the CheckYourPropertyAnswers screen */}
      <AuthRoute
        exact
        path="/landlordApp/property-type"
        component={PropertyType}
      />
      <AuthRoute
        exact
        path="/landlordApp/installation-address"
        component={InstallationAddress}
      />
      <AuthRoute
        exact
        path="/landlordApp/building-type"
        component={BuildingType}
      />
      <AuthRoute
        exact
        path="/landlordApp/parking-type"
        component={ParkingType}
      />
      <AuthRoute
        exact
        path="/landlordApp/private-parking"
        component={LandlordOrPmcPrivateParking}
      />
      <AuthRoute exact path="/landlordApp/unable-to-start-new-application">
        <UnableToStartNewApplication />
      </AuthRoute>
      <AuthRoute exact path="/landlordApp/unable-to-proceed">
        <UnableToProceed />
      </AuthRoute>
      <AuthRoute exact path="/landlordApp/installer-details">
        <InstallerDetails />
      </AuthRoute>
      <AuthRoute exact path="/landlordApp/installer-confirm">
        <InstallerConfirm />
      </AuthRoute>
      <AuthRoute exact path="/landlordApp/number-of-chargepoints">
        <ChargepointInstallation />
      </AuthRoute>
      <AuthRoute exact path="/landlordApp/check-your-answers">
        <CheckYourPropertyAnswers />
      </AuthRoute>
      <AuthRoute exact path="/landlordApp/application-submitted">
        <ApplicationSubmitted />
      </AuthRoute>
      <AuthRoute exact path="/landlordApp/commercial/unable-to-proceed">
        <UnableToProceedStaffOrFleetUsage />
      </AuthRoute>
      <AuthRoute exact path="/landlordApp/select-grant-type">
        <SelectGrantType />
      </AuthRoute>
      <AuthRoute exact path="/landlordApp/commercial/staff-and-fleet">
        <StaffFleetChargepoints />
      </AuthRoute>
      <AuthRoute exact path="/landlordApp/challenge-installation">
        <ChallangeInstallation />
      </AuthRoute>
      <AuthRoute exact path="/landlordApp/challenge-submitted">
        <ChallengeSubmitted />
      </AuthRoute>
    </Switch>
  );
}
